export const trackEvent = ({ action, event_category, event_label, value }) => {
	typeof window !== 'undefined' &&
		window.gtag('event', action, { event_category, event_label, value })
}
